export const MAPBOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN ?? ''